import classNames from 'classnames';
import Link from 'next/link';
import { FC } from 'react';

import { Button } from '../../../components/button/button';
import TrustedByCreators from './assets/trusted-by-creators.png';
import { FAQ } from './faq/faq';
import { useSectionTexts } from './use-section-texts';
import accountStyles from '../../../account.module.css';
import styles from './static-content.module.css';

export const StaticContent: FC<{ onSelectPlan: () => void }> = ({ onSelectPlan }) => {
    const sectionTexts = useSectionTexts();

    return (
        <div className={styles['static-content']}>
            <div className={classNames(accountStyles['account__layout'], accountStyles['account__layout--wide'], styles['static-content__sections'])}>

                {sectionTexts.sections.map((section, index) => (
                    <section
                        // eslint-disable-next-line react/no-array-index-key
                        key={index}
                        className={classNames(styles['static-content__section'], {
                            [styles['static-content__section--swapped']]: index % 2 === 1
                        })}>
                        {section}

                        {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
                        <video
                            className={styles['static-content__video']}
                            src={`/assets/Video ${index + 1}.mp4`}
                            autoPlay
                            playsInline
                            loop
                        />
                    </section>
                ))}

                <section className={styles['static-content__section']}>
                    <div className={styles['static-content__highlight']}>
                        <h2>{sectionTexts.highlightedBlock.title}</h2>
                        <Button type="button" variant="inverted" onClick={onSelectPlan}>
                            Select your plan
                        </Button>

                        <h3><span>Trusted by Industry Pros</span></h3>
                        <div className={styles['static-content__artists-stripe']}>
                            <img
                                src={TrustedByCreators.src}
                                alt="Trusted by Industry Pros"
                            />
                        </div>
                    </div>
                </section>

                <section className={classNames(styles['static-content__section'], styles['static-content__faq'])}>
                    <div>
                        <h2>FAQs</h2>
                        <p>Find answers to commonly asked questions.</p>
                    </div>

                    <div>
                        <FAQ />
                        <p>Still have more questions? Learn more in our <Link href="./support"><a>Support center</a></Link>.</p>
                    </div>
                </section>
            </div>
        </div>
    );
};
